module.exports = __webpack_public_path__ + "static/img/attention.505ca88f.jpg";